"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var FPSManager_1 = require("../controls/fps/FPSManager");
var OrbitControlsManager_1 = require("../controls/orbit/OrbitControlsManager");
var ICameraHandler_1 = require("../../../interfaces/ICameraHandler");
var StateDashboard_1 = require("../../../../../modules/shapediver-state-dashboard/StateDashboard");
exports.PerspectiveCameraHooks = {
    "controls": function (value) {
        if (value !== ICameraHandler_1.ControlType.ORBIT && value !== ICameraHandler_1.ControlType.FPS) {
            this._handlers.threeDManager.warn("PerspectiveCameraHandler.Hook->controls", "The specified control type is not permitted for this camera type.");
            return false;
        }
        if (value === this._perspectiveSettings.getSetting('controls'))
            return true;
        if (value === ICameraHandler_1.ControlType.ORBIT) {
            document.exitPointerLock();
            this._cameraControlsManager = new OrbitControlsManager_1.OrbitControlsManager(this._settings.getSection('controls.orbit'), this._cameraControls, this._handlers.renderingHandler.render, this._handlers.threeDManager.warn);
        }
        else {
            this._cameraControlsManager = new FPSManager_1.FPSManager(this._settings.getSection('controls.fps'), this._cameraControls, this._handlers.renderingHandler.render, this._handlers.threeDManager.warn);
            this._handlers.renderingHandler.getCanvas().requestPointerLock();
        }
        return true;
    },
    "default.position": function (value) {
        if (!this._globalUtils.typeCheck(value, "vector3obj", this._handlers.threeDManager.warn, "PerspectiveCameraHandler.Hook->default.position"))
            return Promise.resolve(false);
        return Promise.resolve(true);
    },
    "default.target": function (value) {
        if (!this._globalUtils.typeCheck(value, "vector3obj", this._handlers.threeDManager.warn, "PerspectiveCameraHandler.Hook->default.target"))
            return Promise.resolve(false);
        return Promise.resolve(true);
    },
    "default": function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var scope, stateDashboard, duration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scope = "PerspectiveCameraHandler.Hook->default";
                        if (!(this._globalUtils.typeCheck(value.position, "vector3obj", this._handlers.threeDManager.warn, scope) && this._globalUtils.typeCheck(value.target, "vector3obj", this._handlers.threeDManager.warn, scope)))
                            return [2 /*return*/, Promise.resolve(false)];
                        stateDashboard = StateDashboard_1.StateDashboardLibrary.getInstance(this._handlers.threeDManager.viewerApi.getSetting('viewerRuntimeId'));
                        duration = stateDashboard.firstTimeVisible.resolved ? this._settings.getSetting('cameraMovementDuration') : 0;
                        if (!(value.position.x === 0 && value.position.y === 0 && value.position.z === 0 && value.target.x === 0 && value.target.y === 0 && value.target.z === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.zoomExtents({ duration: duration })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setPositionAndTarget(value.position, value.target, { duration: duration })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, Promise.resolve(true)];
                }
            });
        });
    },
    "fov": function (value) {
        if (!this._globalUtils.typeCheck(value, "notnegative", this._handlers.threeDManager.warn, "PerspectiveCameraHandler.Hook->fov"))
            return false;
        if (this._camera.fov > 10 && value < 10) {
            this._camera.near *= 100 * value;
            this._camera.far *= 100 * value;
        }
        else if (this._camera.fov < 10 && value > 10) {
            this._camera.near /= 100 * this._camera.fov;
            this._camera.far /= 100 * this._camera.fov;
        }
        this._camera.fov = value;
        this._camera.updateProjectionMatrix();
        this._handlers.renderingHandler.render();
        return true;
    }
};
exports.PerspectiveCameraNotifiers = {};
